import axios from 'axios'

const urlBase = '/compra-direta/api/v1/comprador'


class CompradorIndicePrecoApiClient {

    async buscarUltimoReajustePorModalidade(){
        return await axios.get(`${urlBase}/indices-precos/modalidades/historico-reajustes/ultimo-ano`)
    }

    async buscarModalidades(){
        return await axios.get(`${urlBase}/indices-precos/modalidades`)
    }

    async adicionarModalidadeIndicePreco(payload){
        return await axios.post(`${urlBase}/indices-precos/modalidades`, payload)
    }

    async removerReajusteIndicePreco(modalidadeId, reajusteId){
        return await axios.delete(`${urlBase}/indices-precos/modalidades/${modalidadeId}/reajustes/${reajusteId}`)
    }

    async criarReajusteIndicePreco(dados){
        return await axios.post(`${urlBase}/indices-precos/reajustes`, dados)
    }

    async buscarHistoricoReajuste(modalidadeId){
        return await axios.get(`${urlBase}/indices-precos/modalidades/${modalidadeId}/historico-reajustes`)
    }

    async atualizarPercentualReajuste(dadosAtualizacao) {
        const { id, modalidadeId, ...dados} = dadosAtualizacao
        await axios.put(`${urlBase}/indices-precos/modalidades/${modalidadeId}/reajustes/${id}/atualizar`, dados)
    }

    async salvarReajusteIndicePrecoEmMassa(dadosAtualizacao) {
        await axios.post(`${urlBase}/indices-precos/reajustes/reajustar-em-lote`, dadosAtualizacao)
    }
}

export default new CompradorIndicePrecoApiClient()